import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const SubsectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${MEDIA_QUERIES.mdUp} {
    margin-bottom: 4.5rem;
  }
`;

export const buttonStyles = css`
  row-gap: 0;
  max-width: 100%;
  padding: 0 ${SPACER.medium};
`;
